import { transactionService } from '../services'

export default (type, filters) => {
	return new Promise(resolve => {
		transactionService.getAlertas(type, filters)
			.then(response => resolve({ success: true, data: response.data }))
	})
}
